/** Window event fired after accepting, declining, or leaving, so open views reload team context. */
export const TEAM_MEMBERSHIP_CHANGED_EVENT = "feagi-team-membership-changed";

/** Account hosts the invitee's Accept / Decline card. */
export const TEAM_INVITE_SETTINGS_PATH = "/settings/account";
